export enum DesignItemTagType {
	None = 1,
	TeamWear = 2,
	SyncColors = 3,
}
